export default "__VITE_ASSET__DZFd8yzn__"